// src/routes/hotelRoomCategoriesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import HotelRoomCategories from '../pages/hotelRoomCategories/HotelRoomCategories';
import CreateHotelRoomCategory from '../pages/hotelRoomCategories/CreateHotelRoomCategory';
import EditHotelRoomCategory from '../pages/hotelRoomCategories/EditHotelRoomCategory';
import ProtectedRoute from '../components/global/ProtectedRoute';

const hotelRoomCategoriesRoutes = (
    <>
        {/* Hotel Room Categories List */}
        <Route
            path="/hotel-room-categories"
            element={
                <ProtectedRoute requiredPermission="hotel_room_categories_list">
                    <HotelRoomCategories />
                </ProtectedRoute>
            }
        />

        {/* Hotel Room Categories Archive */}
        <Route
            path="/hotel-room-categories/archive"
            element={
                <ProtectedRoute requiredPermission="hotel_room_categories_archive_list">
                    <HotelRoomCategories />
                </ProtectedRoute>
            }
        />

        {/* Create Hotel Room Category */}
        <Route
            path="/hotel-room-categories/create"
            element={
                <ProtectedRoute requiredPermission="hotel_room_categories_create">
                    <CreateHotelRoomCategory />
                </ProtectedRoute>
            }
        />

        {/* Edit Hotel Room Category */}
        <Route
            path="/hotel-room-categories/:id/edit"
            element={
                <ProtectedRoute requiredPermission="hotel_room_categories_edit">
                    <EditHotelRoomCategory />
                </ProtectedRoute>
            }
        />
    </>
);

export default hotelRoomCategoriesRoutes;
